import { useSystemColorScheme } from '@/ui/theme/hooks/useSystemColorScheme';
import { colorSchemePreferenceState } from '@/ui/theme/states/colorSchemePreferenceState';
import { type ColorScheme } from '@/ui/theme/types/ColorScheme';
import { useAtomStateValue } from '@/ui/utilities/state/jotai/hooks/useAtomStateValue';

export const useColorScheme = (): ColorScheme => {
  const colorSchemePreference = useAtomStateValue(colorSchemePreferenceState);
  const systemColorScheme = useSystemColorScheme();

  return colorSchemePreference === 'system'
    ? systemColorScheme
    : colorSchemePreference;
};
